export default __webpack_public_path__ + "static/23-97ea14e0d20ddf06df3b4b346fdf9bec.jpg";